// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-f442e948],.fade-leave-active[data-v-f442e948]{transition:opacity .2s}.fade-enter[data-v-f442e948],.fade-leave-to[data-v-f442e948]{opacity:0}", ""]);
// Exports
module.exports = exports;
